import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import TestimonialsVideoPopup from './TestimonialsVideoPopup';
import WasilSuccessStory from './images/wasil-success-story.jpg';
import AnantSuccessStory from './images/anant-success-story.jpg';
import ApurvaSuccessStory from './images/apura-success-story.jpg';
import AyushSuccessStory from './images/ayush-success-story.jpg';
import { IconButton } from '@mui/material';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import ShayanSuccessStory from './images/shyan_youtube.webp';
import NiteshSuccessStory from './images/NileshVideo.webp';
import EyonSuccessStory from './images/EyonSuccessStory.webp';
import { AZURE_DEVOPS } from '../constants/AzureDevops';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

function TestimonialsMobileView(props) {
  const { isSmallScreen, heading } = props;

  const images = [
    {
      label: 'Ayush Raj',
      imgPath:
        AyushSuccessStory,
      videoPath: 'https://www.youtube.com/embed/Vx-Xs-2_75o?si=tcbvD0sVHWfjE7kd'
    },
    {
      label: 'Anant Kumar',
      imgPath:
        AnantSuccessStory,
      videoPath: 'https://www.youtube.com/embed/eA6r4AocL9g?si=tdzPMX3gPaYA-BHU'
    },
    {
      label: 'Apurva Raj',
      imgPath:
        ApurvaSuccessStory,
      videoPath: 'https://www.youtube.com/embed/DrID61L12Pc?si=IJBy_DEeKzzuyKc8'
    },
    {
      label: 'Wasil Hasnain',
      imgPath:
        WasilSuccessStory,
      videoPath: 'https://www.youtube.com/embed/HiQo4aDUWfs?si=C1BygYDbKNF47ICh'
    },
    {
      label: 'Syed Shayan Ali',
      imgPath:
        ShayanSuccessStory,
      videoPath: 'https://www.youtube.com/embed/t0l52vDZOLE?si=8h27oIG_L1xbsgAN'
    },
    {
      label: 'Nitesh Kumar',
      imgPath:
      NiteshSuccessStory,
      videoPath: 'https://www.youtube.com/embed/nC4B0DqEu38?si=Qk78AoGTU2qj6FQW'
    },
    {
      label: 'Eyon Utkarsh',
      imgPath:
      EyonSuccessStory,
      videoPath: 'https://www.youtube.com/embed/4QX7UEgL6Ag?si=U_qR9QjrBW2Mns6J'
    }
  ];

  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;
  const [openModal, setOpenModal] = React.useState(false);
  const [videoPath, setVideoPath] = React.useState('');

  const handleOpen = (videoPath) => {
    setVideoPath(videoPath);
    setOpenModal(true);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Box sx={{ width: isSmallScreen ? "100%" : 400, flexGrow: 1, margin: "auto" }}>
      <Paper
        square
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: 50,
          pl: 2,
          bgcolor: 'background.default',
        }}
      >
      </Paper>
      <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {images.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <div>
                <Box
                  component="img"
                  sx={{
                    height: 255,
                    display: 'block',
                    maxWidth: isSmallScreen ? "100%" : 400,
                    overflow: 'hidden',
                    opacity: "80%"
                  }}
                  onClick={(e)=>handleOpen(step.videoPath)}
                  src={step.imgPath}
                />
                <IconButton style={{ position: 'absolute', transform: 'translate(350%, -270%)', color: "white", fontSize: "40px" }}>
                  <PlayCircleIcon fontSize="inherit" onClick={(e)=>handleOpen(step.videoPath)}/>
                </IconButton>
              </div>
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
      <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
      {openModal &&
        <TestimonialsVideoPopup openModal={openModal} setOpenModal={setOpenModal} isSmallScreen={isSmallScreen} videoUrl={videoPath}/>
      }
    </Box>
  );
}

export default TestimonialsMobileView;